const { throwError } = require('./ab-helpers');
const abTypes = require('./ab-types');

const abAnalytics = analytics => {
  if (!analytics) {
    throwError('[abClient] analytics parameter required');
  }

  const trackExperiment = (options, callback) => {
    const experimentData = {
      experiment_name: options.experimentName,
      variant: parseInt(options.variant, 10)
    };

    if (options.experimentNumber !== undefined) {
      experimentData.experiment_number = parseInt(options.experimentNumber, 10);
    }

    analytics.track('track_experiment', experimentData, error => {
      if (error) {
        throwError(error);
      }
      if (callback) {
        callback({
          type: abTypes.EXPERIMENT_TRACKED,
          payload: options.experimentName
        });
      }
    });
  };

  const trackGoal = (options, callback) => {
    analytics.track('track_goal', { goal_name: options.goalName }, error => {
      if (error) {
        throwError(error);
      }
      if (callback) {
        callback({ type: abTypes.GOAL_TRACKED, payload: options.goalName });
      }
    });
  };

  return {
    trackExperiment,
    trackGoal
  };
};

module.exports = abAnalytics;



// WEBPACK FOOTER //
// ./src/ab-analytics.js